import { Crown, Sparkles, X } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { useBreakpoint } from '@/hooks/use-breakpoint.ts';
import { useNavigate } from 'react-router-dom';


interface ServerSponsorBannerProps {
  sponsor: {
    id: string;
    name: string;
    avatar?: string | null;
  };
  onClose?: () => void;
}

export function ServerSponsorBanner({ sponsor }: ServerSponsorBannerProps) {
  const { isMd: isDesktop } = useBreakpoint('md');
  const navigate = useNavigate();
  if (!sponsor) {
    return null;
  }
  if (!isDesktop) return null;

  return (
    <Card
      className={cn(
        'relative overflow-hidden',
        'border-amber-500/30',
        'bg-gradient-to-r from-amber-500/10 via-yellow-500/5 to-transparent',
        'backdrop-blur-sm',
        'animate-in fade-in slide-in-from-top-2 duration-700'
      )}
    >
      <div className="p-2">
        <div className="absolute -right-12 -top-12 h-32 w-32 rounded-full bg-amber-400/15 blur-3xl" />

        <div className="relative flex items-center gap-4 p-4">
          <div className="relative">
            <Avatar className="h-12 w-12 border border-amber-400/40">
              <AvatarImage src={sponsor.avatar || undefined} />
              <AvatarFallback>{sponsor.name.slice(0, 2).toUpperCase()}</AvatarFallback>
            </Avatar>

            <div className="absolute -right-1 -top-1 rounded-full bg-amber-500 p-1 shadow-lg shadow-amber-500/40">
              <Crown className="h-3 w-3 text-white" />
            </div>
          </div>

          <div className="flex-1">
            <div className="flex items-center gap-2">
              <Sparkles className="h-4 w-4 text-amber-400" />

              <span className="text-xs font-semibold uppercase tracking-wider text-amber-500">
                Спонсор сервера — {sponsor.name}.
              </span>
            </div>

            <p className="mt-1 text-sm text-foreground">
              Сервер работает без рекламных аудиовставок благодаря подписке CyberKoala Calls
              пользователя <span className="font-semibold text-amber-500">{sponsor.name}</span>.
            </p>
            {/* TODO: only for non subs*/}
            {/*<button*/}
            {/*  onClick={() => navigate('/channels/@me/boost')}*/}
            {/*  className="mt-4 px-4 py-2 rounded-md bg-indigo-800 hover:bg-indigo-700 text-white text-sm transition"*/}
            {/*>*/}
            {/*  Купить подписку*/}
            {/*</button>*/}
          </div>
        </div>
      </div>
    </Card>

  );
}
